import React, { useState } from 'react';

const MailchimpSubscribeForm = () => {
  const [formData, setFormData] = useState({
    FNAME: '',
    LNAME: '',
    EMAIL: '',
    birthDay: '',
    birthMonth: '',
    birthYear: '',
    'MMERGE7[addr1]': '',
    'MMERGE7[addr2]': '',
    'MMERGE7[city]': '',
    'MMERGE7[state]': '',
    'MMERGE7[zip]': '',
    'MMERGE7[country]': 'Spain',
    MMERGE10: '',
    MMERGE11: '',
    MMERGE12: [],
    termsAccepted: false,
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState({ type: '', text: '' });

  const genreOptions = [
    { name: 'Comedia', groupId: '1' },
    { name: 'Drama', groupId: '2' },
    { name: 'Thriller', groupId: '4' },
    { name: 'Romance', groupId: '8' },
    { name: 'Terror', groupId: '16' },
    { name: 'Ciencia Ficción', groupId: '32' },
    { name: 'Fantasía', groupId: '64' },
    { name: 'Documental', groupId: '128' },
    { name: 'Familiar', groupId: '256' },
    { name: 'Animación', groupId: '512' }
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: checked
    }));
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const handleGenreChange = (genre) => {
    setFormData(prev => {
      const currentGenres = prev.MMERGE12;
      const updatedGenres = currentGenres.includes(genre)
        ? currentGenres.filter(g => g !== genre)
        : [...currentGenres, genre];

      return {
        ...prev,
        MMERGE12: updatedGenres
      };
    });

    if (errors.MMERGE12) {
      setErrors(prev => ({
        ...prev,
        MMERGE12: ''
      }));
    }
  };

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.FNAME) {
      newErrors.FNAME = 'El nombre es obligatorio';
    }

    if (!formData.LNAME) {
      newErrors.LNAME = 'Los apellidos son obligatorios';
    }

    if (!formData.EMAIL) {
      newErrors.EMAIL = 'El correo electrónico es obligatorio';
    } else if (!validateEmail(formData.EMAIL)) {
      newErrors.EMAIL = 'Por favor, introduce un correo electrónico válido';
    }

    if (!formData.birthDay || !formData.birthMonth || !formData.birthYear) {
      newErrors.birthDate = 'La fecha de nacimiento es obligatoria';
    }

    if (!formData['MMERGE7[addr1]']) {
      newErrors['MMERGE7[addr1]'] = 'La calle es obligatoria';
    }

    if (!formData['MMERGE7[city]']) {
      newErrors['MMERGE7[city]'] = 'La localidad es obligatoria';
    }

    if (!formData['MMERGE7[state]']) {
      newErrors['MMERGE7[state]'] = 'La provincia es obligatoria';
    }

    if (!formData['MMERGE7[zip]']) {
      newErrors['MMERGE7[zip]'] = 'El código postal es obligatorio';
    }

    if (!formData['MMERGE7[country]']) {
      newErrors['MMERGE7[country]'] = 'El país es obligatorio';
    }

    if (!formData.MMERGE10) {
      newErrors.MMERGE10 = 'El género es obligatorio';
    }

    if (!formData.MMERGE11) {
      newErrors.MMERGE11 = 'Este campo es obligatorio';
    }

    if (!formData.termsAccepted) {
      newErrors.termsAccepted = 'Debes aceptar los términos y condiciones';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);
    setSubmitMessage({ type: '', text: '' });

    try {
      const url = 'https://afpictures.us5.list-manage.com/subscribe/post-json?u=0bf9139e4ef227ca872943c99&id=e96e3634e1';

      const params = new URLSearchParams({
        FNAME: formData.FNAME,
        LNAME: formData.LNAME,
        EMAIL: formData.EMAIL,
        'MMERGE13[day]': formData.birthDay,
        'MMERGE13[month]': formData.birthMonth,
        'MMERGE13[year]': formData.birthYear,
        'MMERGE7[addr1]': formData['MMERGE7[addr1]'],
        'MMERGE7[addr2]': formData['MMERGE7[addr2]'],
        'MMERGE7[city]': formData['MMERGE7[city]'],
        'MMERGE7[state]': formData['MMERGE7[state]'],
        'MMERGE7[zip]': formData['MMERGE7[zip]'],
        'MMERGE7[country]': formData['MMERGE7[country]'],
        MMERGE10: formData.MMERGE10,
        MMERGE11: formData.MMERGE11,
        b_0bf9139e4ef227ca872943c99_e96e3634e1: '',
      });

      formData.MMERGE12.forEach(genreName => {
        const genre = genreOptions.find(g => g.name === genreName);
        if (genre) {
          params.append(`group[384071][${genre.groupId}]`, genre.groupId);
        }
      });

      console.log('Sending params:', params.toString());
      console.log('Selected genres:', formData.MMERGE12);

      const response = await new Promise((resolve, reject) => {
        const script = document.createElement('script');
        const callbackName = 'mailchimpCallback' + Date.now();

        window[callbackName] = (data) => {
          delete window[callbackName];
          document.body.removeChild(script);
          console.log('Mailchimp response:', data);
          resolve(data);
        };

        script.src = `${url}&${params.toString()}&c=${callbackName}`;
        script.onerror = () => {
          delete window[callbackName];
          document.body.removeChild(script);
          reject(new Error('Failed to load script'));
        };

        document.body.appendChild(script);
      });

      if (response.result === 'success') {
        setSubmitMessage({
          type: 'success',
          text: response.msg || '¡Gracias por suscribirte! Por favor, revisa tu correo para confirmar tu suscripción.'
        });

        setFormData({
          FNAME: '',
          LNAME: '',
          EMAIL: '',
          birthDay: '',
          birthMonth: '',
          birthYear: '',
          'MMERGE7[addr1]': '',
          'MMERGE7[addr2]': '',
          'MMERGE7[city]': '',
          'MMERGE7[state]': '',
          'MMERGE7[zip]': '',
          'MMERGE7[country]': 'Spain',
          MMERGE10: '',
          MMERGE11: '',
          MMERGE12: [],
          termsAccepted: false,
        });
      } else {
        setSubmitMessage({
          type: 'error',
          text: response.msg || 'Hubo un error al procesar tu suscripción. Por favor, inténtalo de nuevo.'
        });
      }

    } catch (error) {
      setSubmitMessage({
        type: 'error',
        text: 'Hubo un error al procesar tu suscripción. Por favor, inténtalo de nuevo.'
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="w-full max-w-2xl mx-auto bg-zinc-900 rounded-lg shadow-lg p-4 md:p-8">
      <h2 className="text-3xl font-semibold text-white mb-2">Suscribir</h2>
      <p className="text-sm text-white mb-6">
        <span className="text-red-500">*</span> indica campo obligatorio
      </p>

      <div className="space-y-6 text-white">
        <div>
          <label htmlFor="FNAME" className="block text-sm font-medium text-gray-100 mb-2">
            Nombre <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="FNAME"
            id="FNAME"
            required
            value={formData.FNAME}
            onChange={handleChange}
            className={`w-full px-4 py-2 text-white bg-zinc-800 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors ${
              errors.FNAME ? 'border-red-500' : 'border-gray-800'
            }`}
          />
          {errors.FNAME && (
            <p className="mt-1 text-sm text-red-600">{errors.FNAME}</p>
          )}
        </div>

        <div>
          <label htmlFor="LNAME" className="block text-sm font-medium text-gray-100 mb-2">
            Apellidos <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="LNAME"
            id="LNAME"
            required
            value={formData.LNAME}
            onChange={handleChange}
            className={`w-full px-4 py-2 text-white bg-zinc-800 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors ${
              errors.LNAME ? 'border-red-500' : 'border-gray-800'
            }`}
          />
          {errors.LNAME && (
            <p className="mt-1 text-sm text-red-600">{errors.LNAME}</p>
          )}
        </div>

        <div>
          <label htmlFor="EMAIL" className="block text-sm font-medium text-gray-100 mb-2">
            Dirección de correo electrónico <span className="text-red-500">*</span>
          </label>
          <input
            type="email"
            name="EMAIL"
            id="EMAIL"
            required
            value={formData.EMAIL}
            onChange={handleChange}
            className={`w-full px-4 py-2 bg-zinc-800 border text-white rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors ${
              errors.EMAIL ? 'border-red-500' : 'border-gray-800'
            }`}
          />
          {errors.EMAIL && (
            <p className="mt-1 text-sm text-red-600">{errors.EMAIL}</p>
          )}
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-100 mb-2">
            Fecha de nacimiento <span className="text-red-500">*</span>
          </label>
          <div className="flex gap-2">
            <input
              type="text"
              name="birthDay"
              placeholder="DD"
              maxLength="2"
              pattern="[0-9]*"
              required
              value={formData.birthDay}
              onChange={handleChange}
              className={`w-20 px-4 py-2 text-white bg-zinc-800 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors ${
                errors.birthDate ? 'border-red-500' : 'border-gray-800'
              }`}
            />
            <span className="flex items-center text-gray-500">/</span>
            <input
              type="text"
              name="birthMonth"
              placeholder="MM"
              maxLength="2"
              pattern="[0-9]*"
              required
              value={formData.birthMonth}
              onChange={handleChange}
              className={`w-20 px-4 py-2 text-white bg-zinc-800 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors ${
                errors.birthDate ? 'border-red-500' : 'border-gray-800'
              }`}
            />
            <span className="flex items-center text-gray-500">/</span>
            <input
              type="text"
              name="birthYear"
              placeholder="AAAA"
              maxLength="4"
              pattern="[0-9]*"
              required
              value={formData.birthYear}
              onChange={handleChange}
              className={`w-28 px-4 py-2 text-white bg-zinc-800 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors ${
                errors.birthDate ? 'border-red-500' : 'border-gray-800'
              }`}
            />
          </div>
          <p className="mt-1 text-xs text-gray-500">( dd / mm / aaaa )</p>
          {errors.birthDate && (
            <p className="mt-1 text-sm text-red-600">{errors.birthDate}</p>
          )}
        </div>

        <div>
          <label htmlFor="MMERGE7-addr1" className="block text-sm font-medium text-gray-100 mb-2">
            Calle <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="MMERGE7[addr1]"
            id="MMERGE7-addr1"
            maxLength="70"
            required
            value={formData['MMERGE7[addr1]']}
            onChange={handleChange}
            placeholder="Nombre de la calle y número"
            className={`w-full px-4 py-2 bg-zinc-800 text-white border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors ${
              errors['MMERGE7[addr1]'] ? 'border-red-500' : 'border-gray-800'
            }`}
          />
          {errors['MMERGE7[addr1]'] && (
            <p className="mt-1 text-sm text-red-600">{errors['MMERGE7[addr1]']}</p>
          )}
        </div>

        <div>
          <label htmlFor="MMERGE7-addr2" className="block text-sm font-medium text-gray-100 mb-2">
            Dirección línea 2
          </label>
          <input
            type="text"
            name="MMERGE7[addr2]"
            id="MMERGE7-addr2"
            maxLength="70"
            value={formData['MMERGE7[addr2]']}
            onChange={handleChange}
            placeholder="Piso, puerta, etc. (opcional)"
            className="w-full px-4 py-2 bg-zinc-800 text-white border border-gray-800 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors"
          />
        </div>

        <div>
          <label htmlFor="MMERGE7-city" className="block text-sm font-medium text-gray-100 mb-2">
            Localidad <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="MMERGE7[city]"
            id="MMERGE7-city"
            maxLength="40"
            required
            value={formData['MMERGE7[city]']}
            onChange={handleChange}
            placeholder="Madrid"
            className={`w-full px-4 py-2 bg-zinc-800 text-white border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors ${
              errors['MMERGE7[city]'] ? 'border-red-500' : 'border-gray-800'
            }`}
          />
          {errors['MMERGE7[city]'] && (
            <p className="mt-1 text-sm text-red-600">{errors['MMERGE7[city]']}</p>
          )}
        </div>

        <div>
          <label htmlFor="MMERGE7-state" className="block text-sm font-medium text-gray-100 mb-2">
            Provincia <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="MMERGE7[state]"
            id="MMERGE7-state"
            maxLength="20"
            required
            value={formData['MMERGE7[state]']}
            onChange={handleChange}
            placeholder="Madrid"
            className={`w-full px-4 py-2 bg-zinc-800 text-white border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors ${
              errors['MMERGE7[state]'] ? 'border-red-500' : 'border-gray-800'
            }`}
          />
          {errors['MMERGE7[state]'] && (
            <p className="mt-1 text-sm text-red-600">{errors['MMERGE7[state]']}</p>
          )}
        </div>

        <div>
          <label htmlFor="MMERGE7-zip" className="block text-sm font-medium text-gray-100 mb-2">
            Código postal <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="MMERGE7[zip]"
            id="MMERGE7-zip"
            maxLength="10"
            required
            value={formData['MMERGE7[zip]']}
            onChange={handleChange}
            placeholder="28001"
            className={`w-full px-4 py-2 bg-zinc-800 text-white border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors ${
              errors['MMERGE7[zip]'] ? 'border-red-500' : 'border-gray-800'
            }`}
          />
          {errors['MMERGE7[zip]'] && (
            <p className="mt-1 text-sm text-red-600">{errors['MMERGE7[zip]']}</p>
          )}
        </div>

        <div>
          <label htmlFor="MMERGE7-country" className="block text-sm font-medium text-gray-100 mb-2">
            País <span className="text-red-500">*</span>
          </label>
          <select
            name="MMERGE7[country]"
            id="MMERGE7-country"
            required
            value={formData['MMERGE7[country]']}
            onChange={handleChange}
            className={`w-full px-4 py-2 text-white bg-zinc-800 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors ${
              errors['MMERGE7[country]'] ? 'border-red-500' : 'border-gray-800'
            }`}
          >
            <option value="Albania">Albania</option>
<option value="Algeria">Algeria</option>
<option value="Andorra">Andorra</option>
<option value="Angola">Angola</option>
<option value="Argentina">Argentina</option>
<option value="Armenia">Armenia</option>
<option value="Australia">Australia</option>
<option value="Austria">Austria</option>
<option value="Azerbaijan">Azerbaijan</option>
<option value="Bahamas">Bahamas</option>
<option value="Bahrain">Bahrain</option>
<option value="Bangladesh">Bangladesh</option>
<option value="Barbados">Barbados</option>
<option value="Belarus">Belarus</option>
<option value="Belgium">Belgium</option>
<option value="Belize">Belize</option>
<option value="Benin">Benin</option>
<option value="Bermuda">Bermuda</option>
<option value="Bhutan">Bhutan</option>
<option value="Bolivia">Bolivia</option>
<option value="Bosnia and Herzegovina">Bosnia and Herzegovina</option>
<option value="Botswana">Botswana</option>
<option value="Brazil">Brazil</option>
<option value="Bulgaria">Bulgaria</option>
<option value="Burkina Faso">Burkina Faso</option>
<option value="Burundi">Burundi</option>
<option value="Cambodia">Cambodia</option>
<option value="Cameroon">Cameroon</option>
<option value="Canada">Canada</option>
<option value="Cape Verde">Cape Verde</option>
<option value="Cayman Islands">Cayman Islands</option>
<option value="Central African Republic">Central African Republic</option>
<option value="Chad">Chad</option>
<option value="Chile">Chile</option>
<option value="China">China</option>
<option value="Colombia">Colombia</option>
<option value="Congo">Congo</option>
<option value="Croatia">Croatia</option>
<option value="Cyprus">Cyprus</option>
<option value="Czech Republic">Czech Republic</option>
<option value="Denmark">Denmark</option>
<option value="Djibouti">Djibouti</option>
<option value="Ecuador">Ecuador</option>
<option value="Egypt">Egypt</option>
<option value="El Salvador">El Salvador</option>
<option value="Equatorial Guinea">Equatorial Guinea</option>
<option value="Eritrea">Eritrea</option>
<option value="Estonia">Estonia</option>
<option value="Ethiopia">Ethiopia</option>
<option value="Fiji">Fiji</option>
<option value="Finland">Finland</option>
<option value="France">France</option>
<option value="Gabon">Gabon</option>
<option value="Gambia">Gambia</option>
<option value="Georgia">Georgia</option>
<option value="Germany">Germany</option>
<option value="Ghana">Ghana</option>
<option value="Greece">Greece</option>
<option value="Guam">Guam</option>
<option value="Guinea">Guinea</option>
<option value="Guinea-Bissau">Guinea-Bissau</option>
<option value="Guyana">Guyana</option>
<option value="Honduras">Honduras</option>
<option value="Hong Kong">Hong Kong</option>
<option value="Hungary">Hungary</option>
<option value="Iceland">Iceland</option>
<option value="India">India</option>
<option value="Indonesia">Indonesia</option>
<option value="Ireland">Ireland</option>
<option value="Israel">Israel</option>
<option value="Italy">Italy</option>
<option value="Japan">Japan</option>
<option value="Jordan">Jordan</option>
<option value="Kazakhstan">Kazakhstan</option>
<option value="Kenya">Kenya</option>
<option value="Kuwait">Kuwait</option>
<option value="Kyrgyzstan">Kyrgyzstan</option>
<option value="Lao People's Democratic Republic">Lao People's Democratic Republic</option>
<option value="Latvia">Latvia</option>
<option value="Lebanon">Lebanon</option>
<option value="Lesotho">Lesotho</option>
<option value="Liberia">Liberia</option>
<option value="Liechtenstein">Liechtenstein</option>
<option value="Lithuania">Lithuania</option>
<option value="Luxembourg">Luxembourg</option>
<option value="Macedonia">Macedonia</option>
<option value="Madagascar">Madagascar</option>
<option value="Malawi">Malawi</option>
<option value="Malaysia">Malaysia</option>
<option value="Maldives">Maldives</option>
<option value="Mali">Mali</option>
<option value="Malta">Malta</option>
<option value="Mauritania">Mauritania</option>
<option value="Mexico">Mexico</option>
<option value="Moldova">Moldova</option>
<option value="Monaco">Monaco</option>
<option value="Mongolia">Mongolia</option>
<option value="Morocco">Morocco</option>
<option value="Mozambique">Mozambique</option>
<option value="Namibia">Namibia</option>
<option value="Nepal">Nepal</option>
<option value="Netherlands">Netherlands</option>
<option value="Netherlands Antilles">Netherlands Antilles</option>
<option value="New Zealand">New Zealand</option>
<option value="Nicaragua">Nicaragua</option>
<option value="Niger">Niger</option>
<option value="Nigeria">Nigeria</option>
<option value="Norway">Norway</option>
<option value="Oman">Oman</option>
<option value="Pakistan">Pakistan</option>
<option value="Panama">Panama</option>
<option value="Paraguay">Paraguay</option>
<option value="Peru">Peru</option>
<option value="Philippines">Philippines</option>
<option value="Poland">Poland</option>
<option value="Portugal">Portugal</option>
<option value="Qatar">Qatar</option>
<option value="Reunion">Reunion</option>
<option value="Romania">Romania</option>
<option value="Russia">Russia</option>
<option value="Rwanda">Rwanda</option>
<option value="Samoa (Independent)">Samoa (Independent)</option>
<option value="Saudi Arabia">Saudi Arabia</option>
<option value="Senegal">Senegal</option>
<option value="Seychelles">Seychelles</option>
<option value="Sierra Leone">Sierra Leone</option>
<option value="Singapore">Singapore</option>
<option value="Slovakia">Slovakia</option>
<option value="Slovenia">Slovenia</option>
<option value="Somalia">Somalia</option>
<option value="South Africa">South Africa</option>
<option value="South Korea">South Korea</option>
<option value="Spain">Spain</option>
<option value="Sri Lanka">Sri Lanka</option>
<option value="Suriname">Suriname</option>
<option value="Swaziland">Swaziland</option>
<option value="Sweden">Sweden</option>
<option value="Switzerland">Switzerland</option>
<option value="Taiwan">Taiwan</option>
<option value="Tanzania">Tanzania</option>
<option value="Thailand">Thailand</option>
<option value="Togo">Togo</option>
<option value="Tunisia">Tunisia</option>
<option value="Turkiye">Turkiye</option>
<option value="Turkmenistan">Turkmenistan</option>
<option value="Uganda">Uganda</option>
<option value="Ukraine">Ukraine</option>
<option value="United Arab Emirates">United Arab Emirates</option>
<option value="Uruguay">Uruguay</option>
<option value="USA">USA</option>
<option value="Uzbekistan">Uzbekistan</option>
<option value="Vatican City State (Holy See)">Vatican City State (Holy See)</option>
<option value="Venezuela">Venezuela</option>
<option value="Vietnam">Vietnam</option>
<option value="Virgin Islands (British)">Virgin Islands (British)</option>
<option value="Yemen">Yemen</option>
<option value="Zambia">Zambia</option>
<option value="Zimbabwe">Zimbabwe</option>
<option value="Antigua And Barbuda">Antigua And Barbuda</option>
<option value="Anguilla">Anguilla</option>
<option value="American Samoa">American Samoa</option>
<option value="Aruba">Aruba</option>
<option value="Brunei Darussalam">Brunei Darussalam</option>
<option value="Bouvet Island">Bouvet Island</option>
<option value="Cook Islands">Cook Islands</option>
<option value="Christmas Island">Christmas Island</option>
<option value="Dominican Republic">Dominican Republic</option>
<option value="Western Sahara">Western Sahara</option>
<option value="Falkland Islands">Falkland Islands</option>
<option value="Faroe Islands">Faroe Islands</option>
<option value="Grenada">Grenada</option>
<option value="French Guiana">French Guiana</option>
<option value="Gibraltar">Gibraltar</option>
<option value="Greenland">Greenland</option>
<option value="Guadeloupe">Guadeloupe</option>
<option value="Guatemala">Guatemala</option>
<option value="Haiti">Haiti</option>
<option value="Jamaica">Jamaica</option>
<option value="Kiribati">Kiribati</option>
<option value="Comoros">Comoros</option>
<option value="Saint Kitts and Nevis">Saint Kitts and Nevis</option>
<option value="Saint Lucia">Saint Lucia</option>
<option value="Marshall Islands">Marshall Islands</option>
<option value="Macau">Macau</option>
<option value="Martinique">Martinique</option>
<option value="Mauritius">Mauritius</option>
<option value="New Caledonia">New Caledonia</option>
<option value="Norfolk Island">Norfolk Island</option>
<option value="Nauru">Nauru</option>
<option value="Niue">Niue</option>
<option value="Papua New Guinea">Papua New Guinea</option>
<option value="Pitcairn">Pitcairn</option>
<option value="Palau">Palau</option>
<option value="Solomon Islands">Solomon Islands</option>
<option value="Svalbard and Jan Mayen Islands">Svalbard and Jan Mayen Islands</option>
<option value="San Marino">San Marino</option>
<option value="Tonga">Tonga</option>
<option value="Timor-Leste">Timor-Leste</option>
<option value="Trinidad and Tobago">Trinidad and Tobago</option>
<option value="Tuvalu">Tuvalu</option>
<option value="Saint Vincent and the Grenadines">Saint Vincent and the Grenadines</option>
<option value="Virgin Islands (U.S.)">Virgin Islands (U.S.)</option>
<option value="Vanuatu">Vanuatu</option>
<option value="Mayotte">Mayotte</option>
<option value="Myanmar">Myanmar</option>
<option value="Sao Tome and Principe">Sao Tome and Principe</option>
<option value="South Georgia and the South Sandwich Islands">South Georgia and the South Sandwich Islands</option>
<option value="Tajikistan">Tajikistan</option>
<option value="United Kingdom">United Kingdom</option>
<option value="Costa Rica">Costa Rica</option>
<option value="Guernsey">Guernsey</option>
<option value="North Korea">North Korea</option>
<option value="Afghanistan">Afghanistan</option>
<option value="Cote D'Ivoire">Cote D'Ivoire</option>
<option value="Cuba">Cuba</option>
<option value="French Polynesia">French Polynesia</option>
<option value="Iran">Iran</option>
<option value="Iraq">Iraq</option>
<option value="Libya">Libya</option>
<option value="Palestine">Palestine</option>
<option value="Syria">Syria</option>
<option value="Aaland Islands">Aaland Islands</option>
<option value="Turks &amp; Caicos Islands">Turks &amp; Caicos Islands</option>
<option value="Jersey  (Channel Islands)">Jersey  (Channel Islands)</option>
<option value="Dominica">Dominica</option>
<option value="Montenegro">Montenegro</option>
<option value="Sudan">Sudan</option>
<option value="Montserrat">Montserrat</option>
<option value="Curacao">Curacao</option>
<option value="Sint Maarten">Sint Maarten</option>
<option value="South Sudan">South Sudan</option>
<option value="Republic of Kosovo">Republic of Kosovo</option>
<option value="Congo, Democratic Republic of the">Congo, Democratic Republic of the</option>
<option value="Isle of Man">Isle of Man</option>
<option value="Saint Martin">Saint Martin</option>
<option value="Bonaire, Saint Eustatius and Saba">Bonaire, Saint Eustatius and Saba</option>
<option value="Serbia">Serbia</option>
          </select>
          {errors['MMERGE7[country]'] && (
            <p className="mt-1 text-sm text-red-600">{errors['MMERGE7[country]']}</p>
          )}
        </div>

        <div>
          <label htmlFor="MMERGE10" className="block text-sm font-medium text-gray-100 mb-2">
            Género <span className="text-red-500">*</span>
          </label>
          <select
            name="MMERGE10"
            id="MMERGE10"
            value={formData.MMERGE10}
            onChange={handleChange}
            className={`w-full px-4 py-2 text-white bg-zinc-800 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors ${
              errors.MMERGE10 ? 'border-red-500' : 'border-gray-800'
            }`}
          >
            <option value="">Seleccionar...</option>
            <option value="Masculino">Masculino</option>
            <option value="Femenino">Femenino</option>
            <option value="No binario/otro">No binario/otro</option>
          </select>
          {errors.MMERGE10 && (
            <p className="mt-1 text-sm text-red-600">{errors.MMERGE10}</p>
          )}
        </div>

        <div>
          <label htmlFor="MMERGE11" className="block text-sm font-medium text-gray-100 mb-2">
            ¿Eres profesional del sector? <span className="text-red-500">*</span>
          </label>
          <select
            name="MMERGE11"
            id="MMERGE11"
            value={formData.MMERGE11}
            onChange={handleChange}
            className={`w-full px-4 py-2 text-white bg-zinc-800 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors ${
              errors.MMERGE11 ? 'border-red-500' : 'border-gray-800'
            }`}
          >
            <option value="">Seleccionar...</option>
            <option value="Sí">Sí</option>
            <option value="No">No</option>
          </select>
          {errors.MMERGE11 && (
            <p className="mt-1 text-sm text-red-600">{errors.MMERGE11}</p>
          )}
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-100 mb-3">
            Intereses Cinematográficos
          </label>
          <div className="space-y-2">
            {genreOptions.map((genre) => (
              <label key={genre.groupId} className="flex items-center space-x-3 cursor-pointer">
                <input
                  type="checkbox"
                  checked={formData.MMERGE12.includes(genre.name)}
                  onChange={() => handleGenreChange(genre.name)}
                  className="w-4 h-4 text-blue-600 bg-zinc-800 border-gray-600 rounded focus:ring-blue-500 focus:ring-2"
                />
                <span className="text-sm text-gray-100">{genre.name}</span>
              </label>
            ))}
          </div>
          {errors.MMERGE12 && (
            <p className="mt-1 text-sm text-red-600">{errors.MMERGE12}</p>
          )}
        </div>

        <div>
          <label className="flex items-start space-x-3 cursor-pointer">
            <input
              type="checkbox"
              name="termsAccepted"
              checked={formData.termsAccepted}
              onChange={handleCheckboxChange}
              className={`w-4 h-4 mt-1 text-blue-600 bg-zinc-800 border rounded focus:ring-blue-500 focus:ring-2 ${
                errors.termsAccepted ? 'border-red-500' : 'border-gray-600'
              }`}
            />
            <span className="text-sm text-gray-100">
              Acepto los <a target="_blank" href="/politica-privacidad" className="text-blue-400 hover:text-blue-300 underline">términos y condiciones</a> <span className="text-red-500">*</span>
            </span>
          </label>
          {errors.termsAccepted && (
            <p className="mt-1 text-sm text-red-600">{errors.termsAccepted}</p>
          )}
        </div>

        <div className="hidden" aria-hidden="true">
          <input
            type="text"
            name="b_0bf9139e4ef227ca872943c99_e96e3634e1"
            tabIndex="-1"
            defaultValue=""
            readOnly
          />
        </div>

        {submitMessage.text && (
          <div
            className={`p-4 rounded-md ${
              submitMessage.type === 'success'
                ? 'bg-green-800 text-white border border-green-600'
                : 'bg-red-500 text-white border border-red-600'
            }`}
          >
            {submitMessage.text}
          </div>
        )}

        <div>
          <button
            type="button"
            onClick={handleSubmit}
            disabled={isSubmitting}
            className="w-full bg-[#735707] uppercase text-white py-3 px-6 rounded-md font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed"
          >
            {isSubmitting ? 'Enviando...' : 'Suscribirse'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MailchimpSubscribeForm;
